import { type FunctionComponent } from 'react';

// components
import { PriceAmount, type PriceAmountProps } from './PriceAmount.tsx';
import { PRICE_TYPES } from './constants.ts';

interface Props extends PriceAmountProps {
    price?: number;
    showPriceLabel: boolean;
    percentageOff?: number;
}

/**
 * Price Components for an item with just a retail price
 */
export const RetailItemPrices: FunctionComponent<Props> = ({
    price,
    currency,
    quantityDisplay,
    showPriceLabel,
    hasPrivateOffer,
    appendElementToPrice,
    displayVatLabel,
    vatLabelClassName,
    priceBookName,
    percentageOff,
}) => (
    /* RETAIL PRICE */
    <PriceAmount
        type={PRICE_TYPES.RETAIL}
        currency={currency}
        amount={price}
        showLabel={showPriceLabel}
        quantityDisplay={quantityDisplay}
        hasPrivateOffer={hasPrivateOffer}
        appendElementToPrice={appendElementToPrice}
        displayVatLabel={displayVatLabel}
        vatLabelClassName={vatLabelClassName}
        priceBookName={priceBookName}
        discount={percentageOff}
    />
);
